import { environment } from './../../../../environment/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { ApiResponse } from './../../../core/models/response-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MaillingServiceService extends CrudService<
  ApiResponse<any>,
  number
> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }

  /* get ListMailing */
  getListMailing( payload : any) {
    let page=1
    if(payload?.page) {
      page = payload.page+1
    }
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/Mailing/getAllMailsForESN?per_page=${payload.per_page}&page=${page}`
    );
  }
  /*get list employee */
  getListEmployees() {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/Mailing/getEmployees`
    );
  }
  /*delete mailing*/
  deleteMailing(MailId: string) {
    const url = `${this._base}/api/Mailing/delete/${MailId}`;
    return this._http.delete(url);
  }
  /*add mailing */
  addMailing(data: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/Mailing/add`,
      data
    );
  }
  /*update mailing */
  updateMailing(
    data: any,
    idMail: number,
    companyType: any
  ): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/Mailing/update/${idMail}`,
      data
    );
  }
  /*serach mailing */
  searchListMailing(data: any) {
    if(data.page){
      data.page=data.page+1
    } else{
      data.page= 1
    }
    return this._http.post<any>(this._base + `/api/Mailing/searchInEsn`, data);
  }
}
